// src/pages/AuthPage.js
import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function AuthPage() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/';
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ email: '', password: '', name: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') await login(form.email, form.password);
      else await register(form);
      navigate(redirect, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">
      <button className="auth-skip" onClick={() => navigate(redirect)}>← Continue browsing</button>
      <div className="auth-content">
        <div className="auth-brand">
          <span className="auth-logo-text">SH</span>
          <h1>StoreHop</h1>
          <p>Sign in to lock deals and save your favourites.</p>
        </div>
        <div className="auth-card">
          <div className="auth-tabs">
            <button className={mode === 'login' ? 'active' : ''} onClick={() => setMode('login')}>Sign In</button>
            <button className={mode === 'register' ? 'active' : ''} onClick={() => setMode('register')}>Create Account</button>
          </div>
          <form onSubmit={submit}>
            {mode === 'register' && (
              <>
                <input name="name" placeholder="Full Name" value={form.name} onChange={handle} required />
                <input name="phone" placeholder="Phone (optional)" value={form.phone} onChange={handle} />
              </>
            )}
            <input name="email" type="email" placeholder="Email" value={form.email} onChange={handle} required />
            <input name="password" type="password" placeholder="Password" value={form.password} onChange={handle} required />
            {error && <p className="auth-error">{error}</p>}
            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? 'Please wait…' : mode === 'login' ? 'Sign In' : 'Create Account'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
